<template>
  <div>
    <div class="flex justify-end py-3 pr-4">
      <div>
        <zt-button
          data-vs-button="rejected-multi"
          class="zt-gtm-documents-inbox-reject-multiple button"
          outlined
          :disabled="
            approveLoadData.loading || approveLoadData.approved ? true : false
          "
          @click="rejectLoad"
        >
          {{
            this.$t("message.uploadImageComponent.topBar.rejectButton")
          }}
        </zt-button>
      </div>
      <div>
        <div
          v-if="approveLoadData.loading || approveLoadData.approved"
          class="statesButton flex items-center justify-center h-10"
          :class="{
            loading: approveLoadData.loading,
            approved: approveLoadData.approved,
          }"
        >
          <div v-if="approveLoadData.loading" class="loader"></div>
          <div v-else><zt-icon name="check" /></div>
        </div>
        <zt-button data-vs-button="approved-multi" v-else class="zt-gtm-documents-inbox-approve-multiple button" outlined @click="approveLoad">{{
          this.$t("message.uploadImageComponent.topBar.approveButton")
        }}</zt-button>
      </div>
    </div>
    <div class="h-16 w-full bg-top-bar">
    </div>
    <div class="flex flex-wrap bg-viewer justify-center items-center visualizerHeight">
      <div class="visualizerDocument flex w-4/5 ">
        <div class="m-auto">
          <div>
            <img height="182" class="mx-auto" src="../../../public/assets/images/uploadFiles/multiple-docs.svg" alt=""/>
          </div>
          <div class="text-center w-7/12 m-auto">
            <span class="text-zt-white text-zt-xl font-medium">
              {{
                this.$t("message.uploadImageComponent.body.rightContainer.multipleSelection")
              }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["isInitHeight", "approveLoadData", "rejectLoadData"],
  methods: {
    approveLoad() {
      this.$emit("approveLoad");
    },
    rejectLoad() {
      this.$emit("openModalAndSaveRejectData");
    },
  }
}
</script>

<style lang="scss" scoped>

@import "./public/assets/scss/_config.scss";

.visualizerHeight {
  height: 70vh;
}

.bg-viewer {
  background-color: #717171;
}

.bg-top-bar {
  background-color: #c4c4c4;
}

.visualizerDocument {
	height: 80%;
}

.button {
  margin-left: 0.5rem;
  min-height: 2.5rem;
  color: #4f41a3 !important;
}
</style>